import revalidator from 'revalidator';
import BaseValidator from './BaseValidator';

const schemas = {
    stripe: {
        properties: {
            card_holder: {
                type: 'string',
                required: true,
                allowEmpty: false
            },
            /*cvc: {
                type: 'string',
                required: true,
                allowEmpty: false
            },
            number: {
                type: 'string',
                required: true,
                allowEmpty: false
            },
            exp_month: {
                type: 'string',
                required: true,
                allowEmpty: false
            },
            exp_year: {
                type: 'string',
                required: true,
                allowEmpty: false
            }*/
        }
    },
    'card-gerencianet': {
        properties: {
            cvc: {
                type: 'string',
                required: true,
                allowEmpty: false
            },
            number: {
                type: 'string',
                required: true,
                allowEmpty: false
            },
            exp_month: {
                type: 'string',
                required: true,
                allowEmpty: false
            },
            exp_year: {
                type: 'string',
                required: true,
                allowEmpty: false
            },
            city: {
                type: 'string',
                required: true,
                allowEmpty: false,
            },
            street: {
                type: 'string',
                required: true,
                allowEmpty: false
            },
            street_number: {
                type: 'string',
                required: true,
                allowEmpty: false
            },
            phone_number: {
                type: 'string',
                required: true,
                allowEmpty: false,
                pattern: /^[\d]+$/, //gc validation /^[1-9]{2}9?[0-9]{8}$/,
                minLength: 10,
                maxLength: 11,
                messages: {
                    pattern: "only_digit_field_error"
                }
            },
            district: {
                type: 'string',
                required: true,
                allowEmpty: false
            },
            province: {
                type: 'string',
                required: true,
                minLength: 2,
                maxLength: 2,
                allowEmpty: false,
                pattern: /^(?:A[CLPM]|BA|CE|DF|ES|GO|M[ATSG]|P[RBAEI]|R[JNSOR]|S[CEP]|TO)$/,
                messages: {
                    pattern: "invalid_province"
                }
            },
            cap: {
                type: 'string',
                required: true,
                allowEmpty: false,
                pattern: /^[\d]+$/, //gc validation ^[0-9]{8}$.,
                minLength: 8,
                maxLength: 8,
                messages: {
                    pattern: "only_digit_field_error"
                }
            },
            fiscal_code: {
                type: 'string',
                required: true,
                pattern: /^[\d]+$/,
                minLength: 11,
                maxLength: 11,
                allowEmpty: false,
                messages: {
                    pattern: "only_digit_field_error"
                }
            }
        }
    },
    boleto: {
        properties: {
            full_name: {
                type: 'string',
                required: true,
                allowEmpty: false,
                conform: fullNameValidator
            },
            city: {
                type: 'string',
                required: true,
                allowEmpty: false,
            },
            street: {
                type: 'string',
                required: true,
                allowEmpty: false
            },
            street_number: {
                type: 'string',
                required: true,
                allowEmpty: false
            },
            phone_number: {
                type: 'string',
                required: true,
                allowEmpty: false,
                pattern: /^[\d]+$/, //gc validation /^[1-9]{2}9?[0-9]{8}$/,
                minLength: 10,
                maxLength: 11,
                messages: {
                    pattern: "only_digit_field_error"
                }
            },
            district: {
                type: 'string',
                required: true,
                allowEmpty: false
            },
            province: {
                type: 'string',
                required: true,
                minLength: 2,
                maxLength: 2,
                allowEmpty: false,
                pattern: /^(?:A[CLPM]|BA|CE|DF|ES|GO|M[ATSG]|P[RBAEI]|R[JNSOR]|S[CEP]|TO)$/,
                messages: {
                    pattern: "invalid_province"
                }
            },
            cap: {
                type: 'string',
                required: true,
                allowEmpty: false,
                pattern: /^[\d]+$/, //gc validation ^[0-9]{8}$.,
                minLength: 8,
                maxLength: 8,
                messages: {
                    pattern: "only_digit_field_error"
                }
            },
            fiscal_code: {
                type: 'string',
                required: true,
                pattern: /^[\d]+$/,
                minLength: 11,
                maxLength: 11,
                allowEmpty: false,
                conform: cpfValidator,
                messages: {
                    pattern: "only_digit_field_error",
                    conform: "invalid_fiscal_code_error"
                }
            }
        }
    },
    pix: {
        properties: {
            fiscal_code: {
                type: 'string',
                required: true,
                pattern: /^[\d]+$/,
                minLength: 11,
                maxLength: 11,
                allowEmpty: false,
                conform: cpfValidator,
                messages: {
                    pattern: "only_digit_field_error",
                    conform: "invalid_fiscal_code_error"
                }
            }
        }
    }
};

//gerencianet rejects the banking billet when customer.name has no surname
function fullNameValidator(input) {
    return `${input}`.trim().split(/\s+/).filter(word => word.length > 0).length >= 2;
}

function cpfValidator(input) {
    let cpf = input.replace(/[^\d]+/g, "");

    while (cpf.length < 11) {
        cpf = `0${cpf}`;
    }

    const expReg = /^0+$|^1+$|^2+$|^3+$|^4+$|^5+$|^6+$|^7+$|^8+$|^9+$/;

    const a = [];
    let b = 0;
    let c = 11;
    for (let i = 0; i < 11; i = i + 1) {
        a[i] = parseInt(cpf.charAt(i), 10);
        if (i < 9) {
            c = c - 1;
            b = b + a[i] * c;
        }
    }

    let x = b % 11;

    if (x < 2) {
        a[9] = 0;
    } else {
        a[9] = 11 - x;
    }

    b = 0;
    c = 11;

    for (let y = 0; y < 10; y = y + 1) {
        b = b + a[y] * c;
        c = c - 1;
    }

    x = b % 11;

    if (x < 2) {
        a[10] = 0;
    } else {
        a[10] = 11 - x;
    }

    let result = true;

    if (
        cpf.charAt(9) !== a[9].toString() ||
        cpf.charAt(10) !== a[10].toString() ||
        cpf.match(expReg)
    ) {
        result = false;
    }

    if (result) {
        return true;
    }
    return false;
}

export default class PaymentValidator extends BaseValidator {

    constructor(payment) {
        super();
        this.slug = payment.active;
        this.values = payment.form;
        this.result = { errors: [], valid: true }
    }

    validate() {
        if (schemas[this.slug]) {
            this.result = revalidator.validate(this.values, schemas[this.slug]);
        }
        return this;
    }

    validateField(field) {
        if (schemas[this.slug].properties[field]) {
            this.result = revalidator.validate(this.values, { properties: { [field]: schemas[this.slug].properties[field] } });
        }
        return this;
    }
}

export function fieldKeyToTransKey(key) {
    const keyToTrans = {
        'number': 'card_number',
        'exp_month': 'expire_date_month',
        'exp_year': 'expire_date_year'
    };
    if (keyToTrans[key]) {
        return keyToTrans[key]
    }
    return key;
}

